'use strict'
import * as Cookies from 'js-cookie'
import {SubmitError} from './errors'

export function postForm(form, url, request) {
  return new Promise((res, rej) => {
    const csrftoken = Cookies.get('csrftoken')
    const data = getDataFromForm(form)
    const urlEncodedData = urlEcodeData(data)

    request.addEventListener('load', data => res(data))
    request.addEventListener('error', err => rej(err))

    request.open('POST', url, true)
    request.withCredentials = true
    request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded')
    request.setRequestHeader('X-CSRFToken', csrftoken)
    request.send(urlEncodedData)
  })
}

export function getDataFromForm(form) {
  if (!form) {
    throw new SubmitError(`Form element was not found! Form: ${form}`)
  }
  const inputs = form.getElementsByTagName('input')
  const data = Array.prototype.reduce.call(inputs, (acc, i) => Object.assign(acc, {[i.name]: i.value}), {})

  return data
}

export function urlEcodeData(data) {
  if (!data) {
    throw new SubmitError(`No data was passed in to encode! Data: ${data}`)
  }
  const urlEncodedDataPairs = []

  for (const name in data) {
    if (data.hasOwnProperty(name)) {
      urlEncodedDataPairs.push(`${encodeURIComponent(name)}=${encodeURIComponent(data[name])}`)
    }
  }

  const urlEncodedData = urlEncodedDataPairs.join('&').replace(/%20/g, '+')
  return urlEncodedData
}
